import React from 'react';
import { CircularProgress, IconButton, Tooltip } from '@mui/material';
import { Dialog } from '../../../../Components/MUIs';
import {
  BuildLegBasicLawSelectOptions,
  LEG_BASIC_DEFAULT_LAW_NM,
} from './LEG_BASIC_Constants';
import './LEG_BASIC_LawSelectDialog.styles.css';

/** 법규준수평가 실시 — 점검표(법령) 선택 팝업 */
function LEG_BASIC_LawSelectDialog({
  open = false,
  onClose = () => {},
  onSelect = () => {},
  onDelete = null,
  lawRows = [],
  loading = false,
}) {
  const options = BuildLegBasicLawSelectOptions(lawRows);

  const GetCardMeta = (option) => {
    if (option.id === 'NEW') {
      return {
        cardClass: 'leg-law-select__card--new',
        icon: 'add_circle',
      };
    }
    if (option.name === LEG_BASIC_DEFAULT_LAW_NM || option.isDefault) {
      return {
        cardClass: 'leg-law-select__card--default',
        icon: 'gavel',
      };
    }
    return {
      cardClass: 'leg-law-select__card--custom',
      icon: 'menu_book',
    };
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="점검표 선택"
      maxWidth="sm"
      fullWidth
      useSaveButton={false}
      closeButtonName="닫기"
      titleSx={{ pb: 1, fontWeight: 700, fontSize: 18 }}
      contentSx={{ pt: 4, px: 2.5, pb: 2.5 }}
      content={
        <div className="leg-law-select">
          <div className="leg-law-select__intro">
            <div className="leg-law-select__intro-icon">
              <span className="material-symbols-outlined">fact_check</span>
            </div>
            <div>
              <div className="leg-law-select__intro-title">
                실시할 법령 점검표를 선택하세요
              </div>
              <p className="leg-law-select__intro-desc">
                기본 제공 점검표와 사업장에서 등록한 법령 점검표를 선택하거나,
                신규 법령을 추가할 수 있습니다. 법령 삭제 시에도 이미 저장된
                기본정보 점검표는 유지됩니다.
              </p>
            </div>
          </div>

          <div className="leg-law-select__list">
            {loading ? (
              <div className="leg-law-select__loading">
                <CircularProgress size={28} sx={{ color: '#2CA900' }} />
                <span>법령 목록을 불러오는 중...</span>
              </div>
            ) : (
              options.map((option) => {
                const meta = GetCardMeta(option);
                return (
                  <div
                    key={option.id}
                    className={`leg-law-select__card ${meta.cardClass}`}
                  >
                    <button
                      type="button"
                      className="leg-law-select__card-main"
                      onClick={() => onSelect(option)}
                    >
                      <div className="leg-law-select__card-icon">
                        <span className="material-symbols-outlined">
                          {meta.icon}
                        </span>
                      </div>
                      <div className="leg-law-select__card-body">
                        <div className="leg-law-select__card-top">
                          <span className="leg-law-select__card-title">
                            {option.name}
                          </span>
                          {option.badge ? (
                            <span className="leg-law-select__badge">
                              {option.badge}
                            </span>
                          ) : null}
                        </div>
                        {option.description ? (
                          <p className="leg-law-select__card-desc">
                            {option.description}
                          </p>
                        ) : null}
                      </div>
                      <span className="leg-law-select__card-arrow">
                        <span className="material-symbols-outlined">
                          chevron_right
                        </span>
                      </span>
                    </button>
                    {option.canDelete && typeof onDelete === 'function' ? (
                      <Tooltip title="법령 삭제 (저장된 평가는 유지)">
                        <IconButton
                          className="leg-law-select__card-delete"
                          size="small"
                          aria-label={`${option.name} 삭제`}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            onDelete(option);
                          }}
                        >
                          <span className="material-symbols-outlined">
                            delete
                          </span>
                        </IconButton>
                      </Tooltip>
                    ) : null}
                  </div>
                );
              })
            )}
          </div>
        </div>
      }
    />
  );
}

export default LEG_BASIC_LawSelectDialog;
